import { Slide } from "react-toastify";
import type { ToastContainerProps } from "react-toastify";

/** Stack above app modals / drawers (DefaultLayout, auth). */
export const APP_TOAST_Z_INDEX = 20050;

/** Main app shell — import once in DefaultLayout. */
export const defaultAppToastContainerProps: ToastContainerProps = {
  transition: Slide,
  position: "top-right",
  autoClose: 6000,
  hideProgressBar: true,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: false,
  draggable: true,
  pauseOnHover: true,
  theme: "light",
  closeButton: false,
  style: { zIndex: APP_TOAST_Z_INDEX },
};

/** Auth routes outside DefaultLayout — spread and override as needed. */
export const defaultAuthToastContainerProps: ToastContainerProps = {
  position: "top-right",
  autoClose: 4000,
  style: { zIndex: APP_TOAST_Z_INDEX },
};
